const state = {
  // 保存用户信息
  UserInfo: {
    LoginStatu: 1, // 0 : 登录成功 1：登录失败（未登录）  2： 其他
    CommLoginStatu: 1, // 通讯登录状态 0 : 登录成功 1：连接失败  2： 服务器认证不通过 3：其他
    User_ID: 0,
    UserName: '', // 用户登录名
    UserGrade_ID: 1, // 用户级别，默认没登陆的是嘉宾油友
    MoblieNo: '', // 用户手机号
    Surplus: 0, // 余额
    Points: 0,
    wxOpenID: '',
    wxUnionID: '',
    RegTime: '',
    LastLoginTime: '',
    Country: '',
    City: '',
    NickName: '',
    ImgName: '' // 操作员头像文件名
  },
  NeedUpdateUserInfo: 0, // 是否需要更新用户资料 0 ： 不需要  1 ： 需要
  ScreenClientWidth: document.documentElement.clientWidth
}

// getters
const getters = {
  GetScreenClientWidth: (state, getters) => {
    return state.ScreenClientWidth
  },

  GetUserInfo: (state, getters) => {
    return state.UserInfo
  },

  GetUserImgSrc: (state, getters) => {
    return state.UserInfo.ImgName
  }
}

// mutations同步更改使用
const mutations = {
  // 更新用户信息
  SetUserInfo (state, newUserInfo) {
    state.UserInfo = newUserInfo
  },

  SetScreenClientWidth (state, newScreenClientWidth) {
    state.ScreenClientWidth = newScreenClientWidth
  },

  SetNeedUpdateUserInfo (state, newNeedUpdateUserInfo) {
    state.NeedUpdateUserInfo = newNeedUpdateUserInfo
  },

  SetCommLoginStatu (state, newCommLoginStatu) {
    state.UserInfo.CommLoginStatu = newCommLoginStatu
  },

  SetLoginStatu (state, newLoginStatu) {
    state.UserInfo.LoginStatu = newLoginStatu
  },

  SetSurplus (state, newSurplus) {
    state.UserInfo.Surplus = newSurplus
  }
}

// actions异步更改使用
const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/BaseStats.js